import { z } from 'zod'

import { ResponsibleType } from '@/ui/modules/admin/views/Responsibles/responsibleType'

export const PatientResponsible = z.object({
  id: z.string(),
  name: z.string(),
  avatarName: z.string(),
  avatar: z.string().nullable(),
  responsibleType: ResponsibleType
})

export type PatientResponsible = z.infer<typeof PatientResponsible>

export const PatientResponsibleList = PatientResponsible.array()
export type PatientResponsibleList = z.infer<typeof PatientResponsibleList>
